import {
  Checkbox as MCheckbox, FormControlLabel, makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const Checkbox = ({
  label, checked, name, onChange, value, disabled, labelFontBold,
  labelStyles, checkboxStyles,
}) => {
  const useStyles = makeStyles(() => ({
    root: {
      '&.MuiCheckbox-colorPrimary.Mui-checked': {
        color: 'inherit',
      },
      '&.Mui-disabled': {
        color: 'rgba(0, 0, 0, 0.26) !important',
      },
      '& + .MuiFormControlLabel-label': {
        fontFamily: 'inherit',
        fontSize: 'inherit',
        color: 'black',
        fontWeight: labelFontBold ? 'bold' : 'normal',
        ...(labelStyles || {}),
      },
      '&.MuiFormControlLabel-root': {
        marginRight: '5px',
      },
      '&.MuiCheckbox-root': {
        ...(checkboxStyles || {}),
      },
    },
  }));
  const useStylesCheckboxLabel = makeStyles(() => ({
    root: {
      marginRight: '5px',
      maxWidth: '100%', // Default to full width for smaller screens
      '@media (min-width:768px)': {
        maxWidth: '50vw', // Apply half screen width for 768px and above
      },
    },
  }));
  const classes = useStyles();
  const classesCheckboxLabel = useStylesCheckboxLabel();
  const CheckboxControl = (
    <MCheckbox
      checked={checked}
      name={name}
      color="primary"
      onChange={onChange}
      disabled={disabled}
      classes={classes}
    />
  );

  return label ? (
    <FormControlLabel
      control={CheckboxControl}
      value={value}
      label={label}
      disabled={disabled}
      classes={classesCheckboxLabel}
      className="text-theme"
    />
  ) : <div className="text-theme inline">{CheckboxControl}</div>;
};

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  checked: PropTypes.bool,
  name: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  labelFontBold: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  labelStyles: PropTypes.shape(),
  checkboxStyles: PropTypes.shape(),
};

Checkbox.defaultProps = {
  label: '',
  checked: false,
  name: '',
  onChange: undefined,
  value: '',
  disabled: false,
  labelFontBold: false,
  labelStyles: {},
  checkboxStyles: {},
};

export default Checkbox;
